import { LifeCyclePosition } from "types/assessmentTypes";

export type IndustryMinMaxRecord = Record<number, { min: number; max: number }>;

export const industriesMinMax: Record<string, IndustryMinMaxRecord> = {
  FOOD_AGRICULTURE: {
    1: { min: 1, max: 7 },
    2: { min: 5, max: 14 },
    3: { min: 65, max: 90 },
    25: { min: 60, max: 85 },
    28: { min: 50, max: 75 },
    26: { min: 20, max: 45 },
    27: { min: 35, max: 60 },
  },
  TEXTILE_APPAREL: {
    1: { min: 0, max: 6 },
    2: { min: 3, max: 11 },
    3: { min: 50, max: 80 },
    25: { min: 55, max: 80 },
    28: { min: 45, max: 70 },
    26: { min: 25, max: 50 },
    27: { min: 30, max: 55 },
  },
  WOOD_FURNITURE: {
    1: { min: 2, max: 8 },
    2: { min: 6, max: 13 },
    3: { min: 60, max: 85 },
    25: { min: 50, max: 75 },
    28: { min: 40, max: 65 },
    26: { min: 30, max: 55 },
    27: { min: 35, max: 60 },
  },
  PAPER_PRINTING: {
    1: { min: 1, max: 5 },
    2: { min: 4, max: 10 },
    3: { min: 55, max: 75 },
    25: { min: 45, max: 70 },
    28: { min: 50, max: 75 },
    26: { min: 35, max: 60 },
    27: { min: 40, max: 65 },
  },
  CHEMICAL_PETROCHEMICAL: {
    1: { min: 3, max: 11 },
    2: { min: 12, max: 26 },
    3: { min: 70, max: 95 },
    25: { min: 55, max: 80 },
    28: { min: 60, max: 85 },
    26: { min: 30, max: 55 },
    27: { min: 35, max: 60 },
  },
  PLASTIC_RUBBER: {
    1: { min: 2, max: 8 },
    2: { min: 5, max: 15 },
    3: { min: 60, max: 85 },
    25: { min: 60, max: 82 },
    28: { min: 55, max: 80 },
    26: { min: 25, max: 50 },
    27: { min: 30, max: 55 },
  },
  NON_METALLIC_MINERALS: {
    1: { min: 0, max: 5 },
    2: { min: 8, max: 20 },
    3: { min: 50, max: 80 },
    25: { min: 65, max: 85 },
    28: { min: 60, max: 82 },
    26: { min: 15, max: 40 },
    27: { min: 30, max: 55 },
  },
  METALS_METALLURGY: {
    1: { min: 2, max: 9 },
    2: { min: 6, max: 17 },
    3: { min: 60, max: 85 },
    25: { min: 60, max: 80 },
    28: { min: 55, max: 78 },
    26: { min: 25, max: 50 },
    27: { min: 35, max: 60 },
  },
  ELECTRONICS_HARDWARE: {
    1: { min: 5, max: 15 },
    2: { min: 8, max: 22 },
    3: { min: 55, max: 82 },
    25: { min: 50, max: 75 },
    28: { min: 45, max: 70 },
    26: { min: 45, max: 70 },
    27: { min: 40, max: 65 },
  },
  INDUSTRIAL_MACHINERY: {
    1: { min: 4, max: 13 },
    2: { min: 7, max: 19 },
    3: { min: 52, max: 78 },
    25: { min: 55, max: 78 },
    28: { min: 50, max: 75 },
    26: { min: 40, max: 65 },
    27: { min: 35, max: 60 },
  },
  AUTOMOTIVE_TRANSPORT: {
    1: { min: 3, max: 10 },
    2: { min: 4, max: 13 },
    3: { min: 60, max: 85 },
    25: { min: 60, max: 82 },
    28: { min: 55, max: 78 },
    26: { min: 35, max: 60 },
    27: { min: 40, max: 65 },
  },
  PHARMA_BIOTECH_MEDICAL: {
    1: { min: 6, max: 16 },
    2: { min: 18, max: 38 },
    3: { min: 70, max: 95 },
    25: { min: 45, max: 70 },
    28: { min: 65, max: 85 },
    26: { min: 50, max: 75 },
    27: { min: 40, max: 65 },
  },
  RENEWABLE_ENERGY: {
    1: { min: 10, max: 25 },
    2: { min: 10, max: 27 },
    3: { min: 45, max: 75 },
    25: { min: 40, max: 65 },
    28: { min: 45, max: 70 },
    26: { min: 55, max: 80 },
    27: { min: 45, max: 70 },
  },
  OIL_GAS_PETROCHEMICAL: {
    1: { min: 1, max: 7 },
    2: { min: 9, max: 22 },
    3: { min: 75, max: 95 },
    25: { min: 65, max: 85 },
    28: { min: 70, max: 90 },
    26: { min: 20, max: 45 },
    27: { min: 35, max: 60 },
  },
  SOFTWARE_IT: {
    1: { min: 15, max: 30 },
    2: { min: 22, max: 42 },
    3: { min: 75, max: 100 },
    25: { min: 35, max: 60 },
    28: { min: 40, max: 65 },
    26: { min: 65, max: 90 },
    27: { min: 50, max: 75 },
  },
  SOFTWARE_IT_DATACENTER: {
    1: { min: 18, max: 35 },
    2: { min: 25, max: 45 },
    3: { min: 70, max: 95 },
    25: { min: 40, max: 65 },
    28: { min: 55, max: 80 },
    26: { min: 60, max: 85 },
    27: { min: 45, max: 70 },
  },
  AEROSPACE_DEFENSE: {
    1: { min: 8, max: 22 },
    2: { min: 12, max: 32 },
    3: { min: 50, max: 80 },
    25: { min: 50, max: 75 },
    28: { min: 60, max: 82 },
    26: { min: 55, max: 80 },
    27: { min: 45, max: 70 },
  },
  OTHER: {
    1: { min: 5, max: 14 },
    2: { min: 10, max: 23 },
    3: { min: 60, max: 86 },
    25: { min: 52, max: 76 },
    28: { min: 53, max: 77 },
    26: { min: 37, max: 62 },
    27: { min: 38, max: 63 },
  },
};

export const pnsCriteriasWieght = {
  1: { type: "positive", weight: 0.2 },
  2: { type: "positive", weight: 0.3 },
  3: { type: "positive", weight: 0.15 },
  25: { type: "positive", weight: 0.05 },
  28: { type: "positive", weight: 0.05 },
  26: { type: "positive", weight: 0.15 },
  27: { type: "positive", weight: 0.1 },
};

export const groupedIndustries = [
  {
    key: "BASELINE",
    industries: ["FOOD_AGRICULTURE", "TEXTILE_APPAREL", "WOOD_FURNITURE"],
    intervals: [
      { title: LifeCyclePosition.DEATH, value: "<=0.10", min: 0, max: 0.1 },
      {
        title: LifeCyclePosition.DECLINE,
        value: "0.11–0.20",
        min: 0.11,
        max: 0.2,
      },
      {
        title: LifeCyclePosition.EARLY_DECLINE,
        value: "0.21–0.30",
        min: 0.21,
        max: 0.3,
      },
      {
        title: LifeCyclePosition.INFANCY,
        value: "0.31–0.40",
        min: 0.31,
        max: 0.4,
      },
      {
        title: LifeCyclePosition.GROWTH,
        value: "0.41–0.55",
        min: 0.41,
        max: 0.55,
      },
      {
        title: LifeCyclePosition.MATURITY,
        value: "0.56–0.70",
        min: 0.56,
        max: 0.7,
      },
      {
        title: LifeCyclePosition.EVOLUTION,
        value: "0.71–0.85",
        min: 0.71,
        max: 0.85,
      },
      {
        title: LifeCyclePosition.STABILITY,
        value: ">=0.86",
        min: 0.86,
        max: 1,
      },
    ],
  },
  {
    key: "HEAVYANDMATURE",
    industries: [
      "PAPER_PRINTING",
      "PLASTIC_RUBBER",
      "NON_METALLIC_MINERALS",
      "METALS_METALLURGY",
      "OIL_GAS_PETROCHEMICAL",
    ],
    intervals: [
      { title: LifeCyclePosition.DEATH, value: "<=0.08", min: 0, max: 0.08 },
      {
        title: LifeCyclePosition.DECLINE,
        value: "0.09–0.15",
        min: 0.09,
        max: 0.15,
      },
      {
        title: LifeCyclePosition.EARLY_DECLINE,
        value: "0.16–0.25",
        min: 0.16,
        max: 0.25,
      },
      {
        title: LifeCyclePosition.INFANCY,
        value: "0.26–0.35",
        min: 0.26,
        max: 0.35,
      },
      {
        title: LifeCyclePosition.GROWTH,
        value: "0.36–0.50",
        min: 0.36,
        max: 0.5,
      },
      {
        title: LifeCyclePosition.MATURITY,
        value: "0.51–0.65",
        min: 0.51,
        max: 0.65,
      },
      {
        title: LifeCyclePosition.EVOLUTION,
        value: "0.66–0.80",
        min: 0.66,
        max: 0.8,
      },
      {
        title: LifeCyclePosition.STABILITY,
        value: ">=0.81",
        min: 0.81,
        max: 1,
      },
    ],
  },
  {
    key: "INDUSTRIALTECHNOLOGICIAL",
    industries: [
      "CHEMICAL_PETROCHEMICAL",
      "INDUSTRIAL_MACHINERY",
      "AUTOMOTIVE_TRANSPORT",
    ],
    intervals: [
      { title: LifeCyclePosition.DEATH, value: "<=0.10", min: 0, max: 0.1 },
      {
        title: LifeCyclePosition.DECLINE,
        value: "0.11–0.18",
        min: 0.11,
        max: 0.18,
      },
      {
        title: LifeCyclePosition.EARLY_DECLINE,
        value: "0.19–0.28",
        min: 0.19,
        max: 0.28,
      },
      {
        title: LifeCyclePosition.INFANCY,
        value: "0.29–0.38",
        min: 0.29,
        max: 0.38,
      },
      {
        title: LifeCyclePosition.GROWTH,
        value: "0.39–0.53",
        min: 0.39,
        max: 0.53,
      },
      {
        title: LifeCyclePosition.MATURITY,
        value: "0.54–0.68",
        min: 0.54,
        max: 0.68,
      },
      {
        title: LifeCyclePosition.EVOLUTION,
        value: "0.69–0.83",
        min: 0.69,
        max: 0.83,
      },
      {
        title: LifeCyclePosition.STABILITY,
        value: ">=0.84",
        min: 0.84,
        max: 1,
      },
    ],
  },
  {
    key: "ADVANCEANDINNOVATIVE",
    industries: [
      "ELECTRONICS_HARDWARE",
      "PHARMA_BIOTECH_MEDICAL",
      "RENEWABLE_ENERGY",
      "AEROSPACE_DEFENSE",
    ],
    intervals: [
      { title: LifeCyclePosition.DEATH, value: "<=0.15", min: 0, max: 0.15 },
      {
        title: LifeCyclePosition.DECLINE,
        value: "0.16–0.25",
        min: 0.16,
        max: 0.25,
      },
      {
        title: LifeCyclePosition.EARLY_DECLINE,
        value: "0.26–0.35",
        min: 0.26,
        max: 0.35,
      },
      {
        title: LifeCyclePosition.INFANCY,
        value: "0.36–0.45",
        min: 0.36,
        max: 0.45,
      },
      {
        title: LifeCyclePosition.GROWTH,
        value: "0.46–0.60",
        min: 0.46,
        max: 0.6,
      },
      {
        title: LifeCyclePosition.MATURITY,
        value: "0.61–0.75",
        min: 0.61,
        max: 0.75,
      },
      {
        title: LifeCyclePosition.EVOLUTION,
        value: "0.76–0.88",
        min: 0.76,
        max: 0.88,
      },
      {
        title: LifeCyclePosition.STABILITY,
        value: ">=0.89",
        min: 0.89,
        max: 1,
      },
    ],
  },
  {
    key: "DIGITAL",
    industries: ["SOFTWARE_IT", "SOFTWARE_IT_DATACENTER"],
    intervals: [
      { title: LifeCyclePosition.DEATH, value: "<=0.18", min: 0, max: 0.18 },
      {
        title: LifeCyclePosition.DECLINE,
        value: "0.19–0.28",
        min: 0.19,
        max: 0.28,
      },
      {
        title: LifeCyclePosition.EARLY_DECLINE,
        value: "0.29–0.38",
        min: 0.29,
        max: 0.38,
      },
      {
        title: LifeCyclePosition.INFANCY,
        value: "0.39–0.48",
        min: 0.39,
        max: 0.48,
      },
      {
        title: LifeCyclePosition.GROWTH,
        value: "0.49–0.62",
        min: 0.49,
        max: 0.62,
      },
      {
        title: LifeCyclePosition.MATURITY,
        value: "0.63–0.78",
        min: 0.63,
        max: 0.78,
      },
      {
        title: LifeCyclePosition.EVOLUTION,
        value: "0.79–0.90",
        min: 0.79,
        max: 0.9,
      },
      {
        title: LifeCyclePosition.STABILITY,
        value: ">=0.91",
        min: 0.91,
        max: 1,
      },
    ],
  },
  {
    key: "OTHER",
    industries: ["OTHER"],
    intervals: [
      { title: LifeCyclePosition.DEATH, value: "<=0.12", min: 0, max: 0.12 },
      {
        title: LifeCyclePosition.DECLINE,
        value: "0.13–0.23",
        min: 0.13,
        max: 0.23,
      },
      {
        title: LifeCyclePosition.EARLY_DECLINE,
        value: "0.24–0.31",
        min: 0.24,
        max: 0.31,
      },
      {
        title: LifeCyclePosition.INFANCY,
        value: "0.32–0.41",
        min: 0.32,
        max: 0.41,
      },
      {
        title: LifeCyclePosition.GROWTH,
        value: "0.42–0.56",
        min: 0.42,
        max: 0.56,
      },
      {
        title: LifeCyclePosition.MATURITY,
        value: "0.57–0.71",
        min: 0.57,
        max: 0.71,
      },
      {
        title: LifeCyclePosition.EVOLUTION,
        value: "0.72–0.85",
        min: 0.72,
        max: 0.85,
      },
      {
        title: LifeCyclePosition.STABILITY,
        value: ">=0.86",
        min: 0.86,
        max: 1,
      },
    ],
  },
];
